export default __webpack_public_path__ + "static/image-two-3c52d272f0dabca35c85b7c41272a322.png";